import BaseApi from './base'
class Features extends BaseApi {
  constructor () {
    super()
  }

  async getAdPageFeatures (adId, adPage, params) {
    return this.auth({
      url: `/ad_features/${adId}/${adPage}`,
      params: params,
      method: 'GET'
    })
  }

  async getAdFeaturePages (adId) {
    return this.auth({
      url: `/ad_feature/pages/${adId}`,
      method: 'GET'
    })
  }

  async getAdFeatureById (adFeatureId, params) {
    return this.auth({
      url: `/ad_feature/${adFeatureId}`,
      method: 'GET',
      params: params
    })
  }

  async createAdFeature (adFeature) {
    return this.auth({
      url: '/ad_feature',
      method: 'POST',
      data: adFeature
    })
  }

  async updateAdFeature (adFeatureId, adFeature, clear_items = false) {
    return this.auth({
      url: `/ad_feature/${adFeatureId}`,
      method: 'PUT',
      data: adFeature,
      params: { clear_items: clear_items }
    })
  }

  async copyAdFeature (payload) {
    return this.auth({
      url: `/ad_feature/copy`,
      method: 'POST',
      data: payload
    })
  }

  async moveAdFeature (payload) {
    return this.auth({
      url: `/ad_feature/move`,
      method: 'POST',
      data: payload
    })
  }

  async massMoveFeatures (payload) {
    return this.auth({
      url: `/ad_feature/mass_move`,
      method: 'POST',
      data: payload
    })
  }

  async checkPromoGap ({ source_ad_id, target_ad_id, source_feature_id, item_source } = {}) {
    return this.auth({
      url: `/ad_feature/check_promo_gap/${source_ad_id}/${target_ad_id}`,
      method: 'GET',
      params: { source_feature_id, item_source }
    })
  }

  async deleteAdFeature (adFeatureId) {
    return this.auth({
      url: `/ad_feature/${adFeatureId}`,
      method: 'DELETE'
    })
  }

  async getFeaturePositions(ad_id, params){
    return this.auth({
      url: `/ad_feature/feature_positions/${ad_id}`,
      method:'GET',
      params:params
    })
  }

  async getEmptyPagePositions(ad_id, page_id){
    return this.auth({
      url: `/ad_feature/empty_positions/${ad_id}/${page_id}`,
      method:'GET',
    })
  }

  async nonPromoLookup(params){
    return this.auth({
      url: `/ad_feature/non-promo-items/`,
      method: 'GET',
      params: params
    })
  }
}

export default new Features()